import { DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

// import { IconButton } from '@/components/ui'
import { useThemeStore } from '@/stores/themeStore'

export const ThemeToggle = () => {
  const { mode, toggleMode } = useThemeStore()

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton onClick={toggleMode} color='inherit'>
        {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
      </IconButton>
    </Tooltip>
  )
}
